// React
import React, { useState, useRef, useEffect } from "react";

// React Async
import Async from "react-async";

// Components
import { Typeahead } from "react-bootstrap-typeahead";

// Internal Libs
import * as EventifyAPI from "../libs/EventifyAPI";

// Style
import "react-bootstrap-typeahead/css/Typeahead.css";
import "react-bootstrap-typeahead/css/Typeahead-bs4.css";

// UUID
const uuidv4 = require("uuid/v4");

const ListSelectionTypeahead = React.forwardRef((props, ref) => {
  const [isLoading, setIsLoading] = useState(false);
  const [originalListArray, setOriginalListArray] = useState([]);
  const [reloadProtocol, setReloadProtocol] = useState(null);
  const [defaultSelectedLists, setDefaultSelectedLists] = useState([]);

  var listData = [];
  var listMap = {};

  // Allow hierarchy to call functions on this component
  // the ref might not actually be necessary
  const dropdownRef = React.useRef();

  useEffect(() => {
    onLoad();
  }, []);

  function onLoad() {
    loadLists();
  }

  React.useImperativeHandle(ref, () => ({
    getSelectedLists: () => {
      return dropdownRef.current.selected;
    },
    setDefaultSelectedLists: (defaultLists) => {
      console.log(defaultLists);
      setDefaultSelectedLists(defaultLists);
      setReloadProtocol(uuidv4());
    }
  }));

  function loadLists() {
    if (props.email === null) {
      return;
    }
    EventifyAPI.fetchAllLists().then( (result) => {
      setOriginalListArray(result);
      setReloadProtocol(uuidv4());
    })
  }

  function convertListAPIResultToDropdown(data) {
    listData = data;

    const listNames = data.map((item, n) => {
      listMap[item.name] = item;
      return item.name;
    });

    console.log(props.selectedDefaults);

    var localCleanDefaults = [];
     if (props.selectedDefaults != null && props.selectedDefaults.length > 0) {
       localCleanDefaults = [props.selectedDefaults[0].name];
     }

     console.log(localCleanDefaults);

    return (
      <Typeahead
        ref={dropdownRef}
        id={props.id}
        labelKey="listNames"
        multiple={props.multiple != null ? props.multiple : true}
        options={listNames}
        placeholder="Find Lists..."
        defaultSelected={localCleanDefaults}
        onChange={selected => {
          const richSelection = selected.map((name, n) => {
            return listMap[name];
          });
          props.onUpdate(richSelection);
        }}
      />
    );
  }

  return (
    <>
      {convertListAPIResultToDropdown(originalListArray)}
    </>
  );
});

export default ListSelectionTypeahead;
